import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Table from "../Table";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";

function TipoProceso(props) {
  const { history } = props;
  const [TipoProcesoStateUpdate, setTipoProcesoStateUpdate] = useState([]);
  const [update, setUpdate] = useState(false);
  const [TipoProcesoState, setTipoProcesoState] = useState([]);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  // eslint-disable-next-line
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  useEffect(() => {
    async function llamadaApi() {
      let response = await fetch(
        Parametros.urlApi + "process_types?skip=0&limit=100&is_mantenedor=true",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);
        setTipoProcesoState(JSON.parse(responseJsonUpdate));
        setTipoProcesoStateUpdate(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }
    llamadaApi();
  }, [update, history, usuario]);
  const [formularioState, setFormularioState] = useState({
    name: "",
  });
  const [editable, setEditable] = useState({
    id: "",
  });
  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };
  let crearTipoProceso = async (event) => {
    event.preventDefault();
    if (usuario.permisos.indexOf("Crear") > -1) {
      event.preventDefault();
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react

        let response = await fetch(Parametros.post + "process_types/", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJson = await response.json();

        if (response.status === 200) {
          alert("se creo correctamente");
          setUpdate(!update);
          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
        }
      } else {
        setEditable({});
      }
    } else {
      alert(usuario.crear);
    }
  };

  let TipoProcesoHandleChange = (index, e) => {
    let newList = TipoProcesoState;
    newList[index][e.target.name] = e.target.value;
    setTipoProcesoState(JSON.parse(JSON.stringify(newList)));
  };
  let confirmarEdicion = async (item) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        let response = await fetch(
          Parametros.urlApi + "process_types/" + item.coll_proc_type_id,
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify({ name: item.name }),
          }
        );

        let responseJson = await response.json();

        if (response.status === 200) {
          setEditable({});
          setTipoProcesoState(JSON.parse(JSON.stringify(TipoProcesoState)));
          setTipoProcesoStateUpdate(
            JSON.parse(JSON.stringify(TipoProcesoState))
          );
          alert("se actualizó corrctamente");
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setTipoProcesoState(
            JSON.parse(JSON.stringify(TipoProcesoStateUpdate))
          );
          setEditable({});
        }
      } else {
        // Do nothing!
        setEditable({});
        setTipoProcesoState(JSON.parse(JSON.stringify(TipoProcesoStateUpdate)));
      }
    } else {
      alert(usuario.editar);
    }
  };

  let editar = (id) => {
    setTipoProcesoState(JSON.parse(JSON.stringify(TipoProcesoStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };
  let cancelarEdicion = async (item) => {
    setEditable({});
    setTipoProcesoState(JSON.parse(JSON.stringify(TipoProcesoStateUpdate)));
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Tipo de proceso"}></UserTab>
        <form id="formularioBusqueda" onSubmit={crearTipoProceso}>
          <div className="col-md-4">
            <h5>Nombre</h5>
            <input
              onChange={handleStageForm}
              name="name"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(TipoProcesoState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={["Nombre "]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={["Nombre"]}></Table>

            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {TipoProcesoState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.coll_proc_type_id}>
                      {editable === item.coll_proc_type_id ? (
                        <>
                          <td>{item.coll_proc_type_id}</td>
                          <td>
                            <input
                              value={item.name}
                              name="name"
                              onChange={(event) => {
                                TipoProcesoHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.coll_proc_type_id}</td>
                          <td>{item.name} </td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.coll_proc_type_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`process_types/${item.coll_proc_type_id}`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(TipoProcesoState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(TipoProceso);
